import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const CircleCheckIcon = forwardRef(({ title = 'Circle Check Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 16 16" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "m14.58 4.09-.44-.6-7.35 7.58a.44.44 0 0 1-.64 0L2.8 7.6a.44.44 0 0 1 .02-.62l.64-.6a.44.44 0 0 1 .62.02l2.4 2.46 6.5-6.67A7.7 7.7 0 0 0 8 .5C3.6.5.5 3.55.5 7.75v.5c0 4.2 3.1 7.25 7.5 7.25s7.5-3.05 7.5-7.25v-.5q-.02-2.05-.92-3.66" })));
});
//# sourceMappingURL=circle_check_icon.js.map